import * as React from 'react';
import { GetString } from '../StringResourceManager';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { CategoryCountRequest } from '../../Interfaces/Assets/CategoryCountRequest';
import { ASSET } from '../../utils/constants';
import { getCurrentIssuesForCategory } from '../../store/Devices/AssetStatesActions';
import { Dispatch } from 'redux';
import clsx from 'clsx';
import DynamicDropDownList from '../DynamicDropDownList';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridAlign: {
      display: 'flex',
      alignItems: 'center',
    },
    applyPadding: {
      paddingLeft: '8px',
    },
  })
);

interface Props {
  onCategoryChange: (category: string) => void;
  onValueChange: (value: string) => void;
  selectedCategory: string;
  selectedValue: string;
}
const CurrentIssueDropDown: React.FC<Props> = ({
  onCategoryChange,
  onValueChange,
  selectedCategory,
  selectedValue,
}): React.ReactElement => {
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();

  const currentIssueCategories: string[] = useSelector(
    (state: ApplicationState) =>
      state.assetStatusesReducer.currentIssueCategories
  );
  const currentIssueValues: Map<CategoryCountRequest, string[]> = useSelector(
    (state: ApplicationState) => state.assetStatusesReducer.currentIssueValues
  );

  const ALL = GetString('ALL');

  const handleCategoryChange = (event: DropDownListChangeEvent) => {
    processFetchCategoryCounts(event.target.value);
    onCategoryChange(event.value);
    onValueChange('');
  };

  React.useEffect(() => {
    if (!currentIssueCategories.includes(ALL))
      currentIssueCategories.unshift(ALL);
  }, [currentIssueCategories]);

  const processFetchCategoryCounts = (category: string) => {
    let categoryCountRequest: CategoryCountRequest = {
      Category: category,
      Name: ASSET.CURRENT_ISSUE,
    };
    let valueExist: boolean = false;
    currentIssueValues.forEach(function (value: any, key: any, map: any) {
      if (JSON.stringify(key) == JSON.stringify(categoryCountRequest)) {
        valueExist = true;
      }
    });

    if (!valueExist) {
      getCurrentIssuesForCategory(dispatch, categoryCountRequest);
    }
  };
  const getDeviceIssuesData = (category: string, name: string) => {
    let categoryCountRequest: CategoryCountRequest = {
      Category: category,
      Name: name,
    };

    var values: any = [];
    currentIssueValues.forEach(function (value: any, key: any, map: any) {
      if (
        key.Category == categoryCountRequest.Category &&
        key.Name == categoryCountRequest.Name
      ) {
        values = value;
      }
    });
    let filtered: string[] = values.filter(function (v: string) {
      return v != '';
    });

    if (filtered.length > 0) filtered.unshift(ALL);
    return filtered;
  };

  const handleValueChange = (event: DropDownListChangeEvent) => {
    onValueChange(event.value);
  };

  return (
    <>
      <Grid
        item
        xs={4}
        className={classes.gridAlign}
        style={{ paddingTop: '24px' }}
      >
        <Typography variant="body1" gutterBottom>
          {GetString('SELECT_CURRENT_ISSUE')}
        </Typography>
      </Grid>
      <Grid
        item
        md={4}
        xs={12}
        className={clsx(classes.gridAlign, classes.applyPadding)}
      >
        <DynamicDropDownList
          data={currentIssueCategories}
          value={selectedCategory}
          onChange={handleCategoryChange}
          label={GetString('CATEGORY_PLACEHOLDER')}
        />
      </Grid>
      <Grid
        item
        md={4}
        xs={12}
        className={clsx(classes.gridAlign, classes.applyPadding)}
      >
        <DynamicDropDownList
          data={getDeviceIssuesData(selectedCategory, ASSET.CURRENT_ISSUE)}
          value={selectedValue}
          onChange={handleValueChange}
          label={GetString('VALUE_PLACEHOLDER')}
        />
      </Grid>
    </>
  );
};
export default CurrentIssueDropDown;
